import React, { useEffect, useState, useRef } from 'react';
import HazardLossChart from './HazardLossChart';
import HazardOccurencesChart from './HazardOccurencesChart';
import { MultiSelect } from 'primereact/multiselect';
import Modal from 'react-bootstrap/Modal';
import envConfig from '../envConfig';
import AnalysisMap from './AnalysisMap';

function DashboardAnalysisTabLatest() {

    const [expandedCountries1, setExpandedCountries1] = useState({});
    const [expandedCountries2, setExpandedCountries2] = useState({});
    const [expandedCountries3, setExpandedCountries3] = useState({});
    const [expandedProvinces1, setExpandedProvinces1] = useState({});
    const [expandedProvinces2, setExpandedProvinces2] = useState({});
    const [expandedProvinces3, setExpandedProvinces3] = useState({});

    const toggleCountry1 = (country) => {
        setExpandedCountries1((prev) => ({
            ...prev,
            [country]: !prev[country],
        }));
    };

    const toggleProvince1 = (province) => {
        setExpandedProvinces1((prev) => ({
            ...prev,
            [province]: !prev[province],
        }));
    };

    const toggleCountry2 = (country) => {
        setExpandedCountries2((prev) => ({
            ...prev,
            [country]: !prev[country],
        }));
    };

    const toggleProvince2 = (province) => {
        setExpandedProvinces2((prev) => ({
            ...prev,
            [province]: !prev[province],
        }));
    };

    const toggleCountry3 = (country) => {
        setExpandedCountries3((prev) => ({
            ...prev,
            [country]: !prev[country],
        }));
    };

    const toggleProvince3 = (province) => {
        setExpandedProvinces3((prev) => ({
            ...prev,
            [province]: !prev[province],
        }));
    };

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const chartRef = useRef(null);
    const chartRef1 = useRef(null);
    const chartRef2 = useRef(null);

    const handleDownload = (chartRef) => {
        if (chartRef?.current) {
            chartRef.current.downloadPNG();
        }
    };

    const [activeTab, setActiveTab] = useState('chart'); // Default active tab
    const handleChartClick = () => {
        setActiveTab('chart');
    };
    const handleTableClick = () => {
        setActiveTab('table');
    };
    const handleMapClick = () => {
        setActiveTab('map');
        scrollBottom()
    };
    const handleSampleClick = () => {
        setActiveTab('sample');
    };

    const [loading, setLoading] = useState(0);
    const [lookUpLoading, setLookUpLoading] = useState(0);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [filteredProvinces, setFilteredProvinces] = useState([]);
    const [hazards, setHazards] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState(null);
    const [selectedProvinces, setSelectedProvinces] = useState(null);
    const [selectedHazards, setSelectedHazards] = useState(null); // Track selected hazard IDs
    const [displayHazard, setDisplayHazard] = useState(null); // Track selected hazard IDs
    const years = [
        1990,
        1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000,
        2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010,
        2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020
    ];

    const [totalHazardData, setTotalHazardData] = useState([]);
    const [totaldeathData, setTotalDeathData] = useState([]);
    const [totaleconomicData, setTotalEconomicData] = useState([]);
    const [hazardChartData, setHazardChartData] = useState(null);
    const [deathLossData, setDeathLossData] = useState(null);
    const [economicLossData, setEconomicLossData] = useState(null);
    const [hazardsCount, setHazardsCount] = useState(null);
    const [headingText, setHeadingText] = useState("country");
    const [headingName, setHeadingName] = useState("Africa");
    const [tableHazardData, setTableHazardData] = useState(null);
    const [geoJsonData, setGeoJsonData] = useState(null);
    const [selectedDataMap, setSelectedDataMap] = useState(null); // Initialize as null or an empty object
    const [getZoom, setGetZoom] = useState({ coordinates: [0.0, 20.0], zoom: 4 });

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch(`${envConfig.API_URL}/lookups/adm0`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();
                return result.data;
            } catch (error) {
                console.error('Failed to fetch countries:', error);
            }
        };

        const fetchHazards = async () => {
            try {
                const response = await fetch(`${envConfig.API_URL}/lookups/hazards`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();
                return { hazards: result.data || [], allHazardIds: result.data.map(item => item.hazard_id) };
            } catch (error) {
                console.error('Failed to fetch hazards:', error);
                throw error;
            }
        };

        const fetchData = async () => {
            try {
                setLookUpLoading(true);

                // Fetch all data in parallel
                const [countries, hazards] = await Promise.all([fetchCountries(), fetchHazards()]);

                // Set states
                setCountries(countries || []);
                let countryIds = countries.map(item => item.adm0_code)
                setSelectedCountries(countryIds || []);

                setHazards(hazards.hazards || []);
                let hazardIds = hazards.hazards.map(item => item.hazard_id)
                setSelectedHazards(hazards.hazards[0] || null);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLookUpLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {

        const fetchProvinces = async () => {
            let payload = {
                "adm0_code": selectedCountries,
            }
            let url = `/lookups/adm1`;
            try {
                const response = await fetch(`${envConfig.API_URL}${url}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const result = await response.json();
                const provinceData = result.data.filter(item => item.adm1_name != 'Administrative unit not available');
                setProvinces(provinceData)
            } catch (error) {
                console.error("Failed to send analysis charts:", error);
            }
        };
        if (selectedCountries && selectedCountries.length > 1) {
            fetchProvinces()
        }
        setSelectedProvinces(null)
    }, [selectedCountries])

    useEffect(() => {

        const fetchGeojson = async () => {
            try {
                const response = await fetch('/data/africa.geojson');
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                return await response.json();
            } catch (error) {
                console.error('Failed to fetch GeoJSON:', error);
                throw error;
            }
        };

        const countryIds = countries.map(item => item.adm0_code)

        const fetchHazardCharts = async () => {
            const hazardIds = hazards.map(item => item.hazard_id)
            let payload = {
                "purpose": "stats",
                "admX": 2,
                "adm0_code": countryIds,
                "adm1_code": [],
                "hazard_ids": hazardIds
            }
            let url = `/hazards/multihazard`;
            try {
                const response = await fetch(`${envConfig.API_URL}${url}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const result = await response.json();

                return result;

            } catch (error) {
                console.error("Failed to send analysis charts:", error);
            }
        };

        const fetchLossData = async (lossId) => {
            try {
                let payload = {
                    "purpose": "stats",
                    "admX": 2,
                    "adm0_code": countryIds,
                    "adm1_code": [],
                    "hazard_id": 2,
                    "loss_id": lossId,
                    "dataset": "losses",
                    "total": false,
                    "years": years
                };

                let url = `/hazards/timeseries`;
                const response = await fetch(`${envConfig.API_URL}${url}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) throw new Error(`Error: ${response.status}`);

                return await response.json();
            } catch (error) {
                console.error("Failed to fetch loss data:", error);
                return null;
            }
        };

        const fetchData = async () => {
            try {
                setLoading(prev => prev + 1);
                const [geoJson, hazardChartData, deathLossData, economicLossData] = await Promise.all([
                    fetchGeojson(),
                    fetchHazardCharts(),
                    fetchLossData(1), // Death Loss
                    fetchLossData(2)  // Economic Loss
                ]);
                setGeoJsonData(geoJson);

                let legend = hazardChartData.data.legend
                let chartData = hazardChartData.data.matrix
                chartData = chartData.filter(item => item.adm2_name != 'Administrative unit not available');
                setTotalHazardData(chartData)
                getHazardsCount(chartData);
                setDisplayHazard(hazards[0])
                getTop10Data(chartData, hazards[0].symbol, "country");

                let deathData = deathLossData.data;
                deathData = deathData ? deathData.filter(item => item.adm2_name !== 'Administrative unit not available') : [];
                setTotalDeathData(deathData)
                getLossesData(deathData, "country", "death");

                let economicData = economicLossData.data;
                economicData = economicData ? economicData.filter(item => item.adm2_name !== 'Administrative unit not available') : [];
                setTotalEconomicData(economicData)
                getLossesData(economicData, "country", "economic");

                getTableData(chartData, deathData, economicData)
                generateMapDataFromGeoJSON(geoJson, chartData);


            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(prev => (prev > 0 ? prev - 1 : 0));
            }
        };

        if (selectedHazards) {
            fetchData();
        }
    }, [lookUpLoading]);

    const getHazardsCount = (chartData) => {
        const sumByKeys = chartData.reduce((acc, obj) => {
            Object.keys(obj).forEach(key => {
                if (!["adm0_code", "adm0_name", "adm1_code", "adm1_name", "adm2_code", "adm2_name"].includes(key)) {
                    acc[key] = (acc[key] || 0) + obj[key];
                }
            });
            return acc;
        }, {});
        setHazardsCount(sumByKeys)
    }

    const getTop10Data = (totalData, hazardSymbol, type) => {
        const colors = [
            "#F2817C", "#0E6BD0", "#DB528B", "#59BDE9", "#FF9602",
            "#81858D", "#27737D", "#D5B2E7", "#4CAF50", "#FF5733"
        ];

        if (type === "country") {

            // Aggregate data by country
            const countryTotals = totalData.reduce((acc, obj) => {
                const country = obj.adm0_name;
                if (!acc[country]) {
                    acc[country] = 0;
                }
                acc[country] += obj[hazardSymbol] || 0; // Sum the values for the given hazard symbol
                return acc;
            }, {});

            // Convert object to array and sort by value in descending order
            const sortedCountries = Object.entries(countryTotals)
                .map(([country, value]) => ({ name: country, y: value }))
                .sort((a, b) => b.y - a.y) // Sort by highest value first
                .slice(0, 10) // Take top 10 countries
                .map((item, index) => ({ ...item, color: colors[index % colors.length] })); // Assign colors

            setHazardChartData(sortedCountries);

            return sortedCountries;

        } else if (type === "province") {

            // Aggregate data by province
            const provinceTotals = totalData.reduce((acc, obj) => {
                const province = obj.adm1_name;
                if (!acc[province]) {
                    acc[province] = 0;
                }
                acc[province] += obj[hazardSymbol] || 0; // Sum the values for the given hazard symbol
                return acc;
            }, {});

            // Convert object to array and sort by value in descending order
            const sortedProvinces = Object.entries(provinceTotals)
                .map(([province, value]) => ({ name: province, y: value }))
                .sort((a, b) => b.y - a.y) // Sort by highest value first
                .slice(0, 10) // Take top 10 countries
                .map((item, index) => ({ ...item, color: colors[index % colors.length] })); // Assign colors

            setHazardChartData(sortedProvinces);

            return sortedProvinces;

        } else if (type === "district") {

            // Aggregate data by district
            const districtTotals = totalData.reduce((acc, obj) => {
                const district = obj.adm2_name;
                if (!acc[district]) {
                    acc[district] = 0;
                }
                acc[district] += obj[hazardSymbol] || 0; // Sum the values for the given hazard symbol
                return acc;
            }, {});

            // Convert object to array and sort by value in descending order
            const sortedDistricts = Object.entries(districtTotals)
                .map(([district, value]) => ({ name: district, y: value }))
                .sort((a, b) => b.y - a.y) // Sort by highest value first
                .slice(0, 10) // Take top 10 countries
                .map((item, index) => ({ ...item, color: colors[index % colors.length] })); // Assign colors

            setHazardChartData(sortedDistricts);

            return sortedDistricts;

        }
    };

    const getLossesData = (totalData, type, subType) => {
        if (type === "country") {

            let countryMap = {};

            // Loop through each district record
            totalData.forEach(district => {
                let country = district.adm0_name; // Country name
                let countryCode = district.adm0_code; // Country code
                let temporal = district.temporal;

                // If country doesn't exist in map, initialize it
                if (!countryMap[country]) {
                    countryMap[country] = {
                        "Country Code": countryCode,
                        "Indicator Name": "Population, total",
                        "Indicator Code": "SP.POP.TOTL"
                    };
                }

                // Sum the population data for each year
                Object.keys(temporal).forEach(year => {
                    countryMap[country][year] = (countryMap[country][year] || 0) + temporal[year];
                });
            });

            if (subType === "death") {
                setDeathLossData(countryMap)
            } else {
                setEconomicLossData(countryMap)
            }

            return countryMap;

        } else if (type === "province") {

            let provinceMap = {};

            // Loop through each district record
            totalData.forEach(district => {
                let province = district.adm1_name; // Country name
                let provinceCode = district.adm1_code; // Country code
                let temporal = district.temporal;

                // If province doesn't exist in map, initialize it
                if (!provinceMap[province]) {
                    provinceMap[province] = {
                        "Country Code": provinceCode,
                        "Indicator Name": "Population, total",
                        "Indicator Code": "SP.POP.TOTL"
                    };
                }

                // Sum the population data for each year
                Object.keys(temporal).forEach(year => {
                    provinceMap[province][year] = (provinceMap[province][year] || 0) + temporal[year];
                });
            });

            if (subType === "death") {
                setDeathLossData(provinceMap)
            } else {
                setEconomicLossData(provinceMap)
            }

            return provinceMap;

        } else if (type === "district") {

            let districtMap = {};

            // Loop through each district record
            totalData.forEach(districtData => {
                let district = districtData.adm2_name; // Country name
                let districtCode = districtData.adm2_code; // Country code
                let temporal = districtData.temporal;

                // If district doesn't exist in map, initialize it
                if (!districtMap[district]) {
                    districtMap[district] = {
                        "Country Code": districtCode,
                        "Indicator Name": "Population, total",
                        "Indicator Code": "SP.POP.TOTL"
                    };
                }

                // Sum the population data for each year
                Object.keys(temporal).forEach(year => {
                    districtMap[district][year] = (districtMap[district][year] || 0) + temporal[year];
                });
            });

            if (subType === "death") {
                setDeathLossData(districtMap)
            } else {
                setEconomicLossData(districtMap)
            }

            return districtMap;

        }
    }

    function getTableData(chartData, deathData, economicData) {
        const result = [];
        const countryMap = new Map();

        // Convert deathData and economicData into Maps for quick lookup
        const deathMap = new Map();
        deathData.forEach(death => {
            const key = `${death.adm0_code}-${death.adm1_code}-${death.adm2_code}`;
            deathMap.set(key, death.temporal);
        });

        const economicMap = new Map();
        economicData.forEach(economic => {
            const key = `${economic.adm0_code}-${economic.adm1_code}-${economic.adm2_code}`;
            economicMap.set(key, economic.temporal);
        });

        chartData.forEach(item => {
            const {
                adm0_code, adm0_name,
                adm1_code, adm1_name,
                adm2_code, adm2_name,
                D, E, F, L, Q, S, T, V, W
            } = item;

            const values = { D, E, F, L, Q, S, T, V, W };
            const key = `${adm0_code}-${adm1_code}-${adm2_code}`;

            // Fetch death and economic temporal data if available
            const deathTemporal = deathMap.get(key) || {};
            const economicTemporal = economicMap.get(key) || {};

            if (!countryMap.has(adm0_code)) {
                countryMap.set(adm0_code, {
                    country: adm0_name,
                    country_code: adm0_code,
                    temporalDeath: {},
                    temporalEconomic: {},
                    values: { D: 0, E: 0, F: 0, L: 0, Q: 0, S: 0, T: 0, V: 0, W: 0 },
                    provinces: new Map()
                });
            }

            const country = countryMap.get(adm0_code);
            Object.keys(values).forEach(key => country.values[key] += values[key]);

            if (!country.provinces.has(adm1_code)) {
                country.provinces.set(adm1_code, {
                    province: adm1_name,
                    province_code: adm1_code,
                    temporalDeath: {},
                    temporalEconomic: {},
                    values: { D: 0, E: 0, F: 0, L: 0, Q: 0, S: 0, T: 0, V: 0, W: 0 },
                    districts: new Map()
                });
            }

            const province = country.provinces.get(adm1_code);
            Object.keys(values).forEach(key => province.values[key] += values[key]);

            if (!province.districts.has(adm2_code)) {
                province.districts.set(adm2_code, {
                    district: adm2_name,
                    district_code: adm2_code,
                    temporalDeath: {},
                    temporalEconomic: {},
                    values: { D: 0, E: 0, F: 0, L: 0, Q: 0, S: 0, T: 0, V: 0, W: 0 }
                });
            }

            const district = province.districts.get(adm2_code);
            Object.keys(values).forEach(key => district.values[key] += values[key]);

            // Ensure aggregation at all levels
            Object.keys(deathTemporal).forEach(year => {
                const deaths = deathTemporal[year];

                // Add to district
                district.temporalDeath[year] = (district.temporalDeath[year] || 0) + deaths;

                // Aggregate correctly to province
                province.temporalDeath[year] = (province.temporalDeath[year] || 0) + deaths;

                // Aggregate correctly to country
                country.temporalDeath[year] = (country.temporalDeath[year] || 0) + deaths;
            });

            Object.keys(economicTemporal).forEach(year => {
                const economic = economicTemporal[year];

                // Add to district
                district.temporalEconomic[year] = (district.temporalEconomic[year] || 0) + economic;

                // Aggregate correctly to province
                province.temporalEconomic[year] = (province.temporalEconomic[year] || 0) + economic;

                // Aggregate correctly to country
                country.temporalEconomic[year] = (country.temporalEconomic[year] || 0) + economic;
            });
        });

        // Convert Maps to arrays
        countryMap.forEach(country => {
            country.provinces.forEach(province => {
                province.districts = Array.from(province.districts.values());
            });
            country.provinces = Array.from(country.provinces.values());
            result.push(country);
        });

        setTableHazardData(result);

    }

    const generateMapDataFromGeoJSON = (geojson, chartData) => {
        let data = {
            geojson: [],
            legend: []
        }

        let mapData = {
            type: "FeatureCollection",
            features: []
        }

        let responseColorPallet = getColorPallet();
        let colorPallet = responseColorPallet[selectedHazards.hazard_id]

        geojson.features.forEach((feature) => {
            if (feature.geometry && feature.geometry.type === "Polygon") {
                let mapFeature = feature
                const filtered = chartData.filter(item => item.adm2_code === mapFeature.properties.ADM2_CODE);
                if (filtered.length > 0) {
                    const value = filtered[0][selectedHazards?.symbol];
                    mapFeature.properties.value = value;
                    mapFeature.properties.color = colorPallet[value]?.color ?? 'transparent'; // Default color if no match
                    const country = countries.find(item => item.adm0_code === mapFeature.properties.ADM0_CODE);
                    mapFeature.properties.country = country.adm0_name ?? 'N/A';
                    mapData.features.push(mapFeature)
                }
            }
        });

        data.geojson = mapData
        data.legend = Object.values(colorPallet)
        setSelectedDataMap(data);
    };



    const getColorPallet = () => {
        return {
            2: { // flood
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#b5caff",
                    "value": 1
                },
                2: {
                    "color": "#abc0ff",
                    "value": 2
                },
                3: {
                    "color": "#9db8ff",
                    "value": 3
                },
                4: {
                    "color": "#95b0ff",
                    "value": 4
                },
                5: {
                    "color": "#87a7fe",
                    "value": 5
                },
                6: {
                    "color": "#79a0ff",
                    "value": 6
                },
                7: {
                    "color": "#6e97ff",
                    "value": 7
                },
                8: {
                    "color": "#6191ff",
                    "value": 8
                },
                9: {
                    "color": "#5486ff",
                    "value": 9
                },
                10: {
                    "color": "#4580fe",
                    "value": 10
                },
                11: {
                    "color": "#347afe",
                    "value": 11
                },
                12: {
                    "color": "#1c73ff",
                    "value": 12
                },
                13: {
                    "color": "#005adf",
                    "value": 13
                },
                14: {
                    "color": "#0253d6",
                    "value": 14
                },
                15: {
                    "color": "#014fcb",
                    "value": 15
                },
                16: {
                    "color": "#024dc4",
                    "value": 16
                },
                17: {
                    "color": "#0245ba",
                    "value": 17
                },
                18: {
                    "color": "#0242b0",
                    "value": 18
                },
                19: {
                    "color": "#033ea6",
                    "value": 19
                },
                20: {
                    "color": "#013b9e",
                    "value": 20
                },
                23: {
                    "color": "#003593",
                    "value": 23
                },
                24: {
                    "color": "#01338c",
                    "value": 24
                },
                25: {
                    "color": "#022c82",
                    "value": 25
                },
                26: {
                    "color": "#012a7a",
                    "value": 26
                },
                28: {
                    "color": "#002573",
                    "value": 28
                }
            },
            3: { // drought
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#ffeb08",
                    "value": 1
                },
                2: {
                    "color": "#ffd20a",
                    "value": 2
                },
                3: {
                    "color": "#ffba0d",
                    "value": 3
                },
                4: {
                    "color": "#fda50f",
                    "value": 4
                },
                5: {
                    "color": "#f07e1b",
                    "value": 5
                },
                6: {
                    "color": "#e36125",
                    "value": 6
                },
                7: {
                    "color": "#d6462c",
                    "value": 7
                },
                8: {
                    "color": "#c83233",
                    "value": 8
                },
                9: {
                    "color": "#b32825",
                    "value": 9
                },
                11: {
                    "color": "#9c1a18",
                    "value": 11
                },
                12: {
                    "color": "#88120e",
                    "value": 12
                },
                13: {
                    "color": "#720000",
                    "value": 13
                }

            },
            4: { // earthquake
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#ffa600",
                    "value": 1
                },
                2: {
                    "color": "#ff5100",
                    "value": 2
                },
                3: {
                    "color": "#fe1100",
                    "value": 3
                },
                4: {
                    "color": "#c80000",
                    "value": 4
                },
                5: {
                    "color": "#800000",
                    "value": 5
                }
            },
            5: { // epidemic
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#e0ce00",
                    "value": 1
                },
                2: {
                    "color": "#e3bd00",
                    "value": 2
                },
                3: {
                    "color": "#e3ae00",
                    "value": 3
                },
                4: {
                    "color": "#e69d00",
                    "value": 4
                },
                5: {
                    "color": "#e78e00",
                    "value": 5
                },
                6: {
                    "color": "#e67f00",
                    "value": 6
                },
                7: {
                    "color": "#e36a01",
                    "value": 7
                },
                8: {
                    "color": "#e25b01",
                    "value": 8
                },
                9: {
                    "color": "#e14b00",
                    "value": 9
                },
                10: {
                    "color": "#df3400",
                    "value": 10
                },
                14: {
                    "color": "#dd1e01",
                    "value": 14
                }
            },
            6: { // extreme temperature
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#ffba0d",
                    "value": 1
                },
                2: {
                    "color": "#e36125",
                    "value": 2
                },
                3: {
                    "color": "#b32825",
                    "value": 3
                },
                4: {
                    "color": "#720000",
                    "value": 4
                }
            },
            7: { // landslide
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#ffebb0",
                    "value": 1
                },
                2: {
                    "color": "#ffd380",
                    "value": 2
                },
                3: {
                    "color": "#e69800",
                    "value": 3
                },
                4: {
                    "color": "#f57b7a",
                    "value": 4
                }

            },
            8: { // storm
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#fff321",
                    "value": 1
                },
                2: {
                    "color": "#ffe733",
                    "value": 2
                },
                3: {
                    "color": "#fed940",
                    "value": 3
                },
                4: {
                    "color": "#fecc49",
                    "value": 4
                },
                5: {
                    "color": "#ffc154",
                    "value": 5
                },
                6: {
                    "color": "#ffb55e",
                    "value": 6
                },
                7: {
                    "color": "#ffa768",
                    "value": 7
                },
                8: {
                    "color": "#ff9a70",
                    "value": 8
                },
                9: {
                    "color": "#ff7f7e",
                    "value": 9
                },
                10: {
                    "color": "#ff5500",
                    "value": 10
                }
            },
            9: { // volcanic
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#e36125",
                    "value": 1
                },
                2: {
                    "color": "#720000",
                    "value": 2
                }
            },
            10: { // wildfire
                0: {
                    "color": "transparent",
                    "value": 0
                },
                1: {
                    "color": "#ffa77f",
                    "value": 1
                },
                2: {
                    "color": "#e54c00",
                    "value": 2
                }
            }
        }

    }

    const getCountryCoordinates = (country_id) => {
        const countries = [
            {
                "adm0_code": 102,
                "adm0_name": "Abyei",
                "coordinates": { "lat": 8.3333, "lng": 29.6667, "zoom": 6 }
            },
            {
                "adm0_code": 4,
                "adm0_name": "Algeria",
                "coordinates": { "lat": 28.0339, "lng": 1.6596, "zoom": 5 }
            },
            {
                "adm0_code": 8,
                "adm0_name": "Angola",
                "coordinates": { "lat": -11.2027, "lng": 17.8739, "zoom": 6 }
            },
            {
                "adm0_code": 25,
                "adm0_name": "Bassas da India",
                "coordinates": { "lat": -17.85, "lng": 39.9, "zoom": 7 }
            },
            {
                "adm0_code": 29,
                "adm0_name": "Benin",
                "coordinates": { "lat": 9.3075, "lng": 2.3158, "zoom": 6 }
            },
            {
                "adm0_code": 35,
                "adm0_name": "Botswana",
                "coordinates": { "lat": -22.3285, "lng": 24.6849, "zoom": 6 }
            },
            {
                "adm0_code": 42,
                "adm0_name": "Burkina Faso",
                "coordinates": { "lat": 12.2383, "lng": -1.5616, "zoom": 6 }
            },
            {
                "adm0_code": 43,
                "adm0_name": "Burundi",
                "coordinates": { "lat": -3.3731, "lng": 29.9189, "zoom": 6 }
            },
            {
                "adm0_code": 45,
                "adm0_name": "Cameroon",
                "coordinates": { "lat": 3.848, "lng": 11.5021, "zoom": 6 }
            },
            {
                "adm0_code": 47,
                "adm0_name": "Cape Verde",
                "coordinates": { "lat": 16.5385, "lng": -23.0418, "zoom": 7 }
            },
            {
                "adm0_code": 49,
                "adm0_name": "Central African Republic",
                "coordinates": { "lat": 6.6111, "lng": 20.9394, "zoom": 6 }
            },
            {
                "adm0_code": 50,
                "adm0_name": "Chad",
                "coordinates": { "lat": 15.4542, "lng": 18.7322, "zoom": 6 }
            },
            {
                "adm0_code": 58,
                "adm0_name": "Comoros",
                "coordinates": { "lat": -11.875, "lng": 43.872, "zoom": 8 }
            },
            {
                "adm0_code": 59,
                "adm0_name": "Congo",
                "coordinates": { "lat": -4.0383, "lng": 21.7587, "zoom": 6 }
            },
            {
                "adm0_code": 66,
                "adm0_name": "Côte d'Ivoire",
                "coordinates": { "lat": 7.539, "lng": -5.5471, "zoom": 6 }
            },
            {
                "adm0_code": 68,
                "adm0_name": "Democratic Republic of the Congo",
                "coordinates": { "lat": -4.0383, "lng": 21.7587, "zoom": 5 }
            },
            {
                "adm0_code": 70,
                "adm0_name": "Djibouti",
                "coordinates": { "lat": 11.8251, "lng": 42.5903, "zoom": 7 }
            },
            {
                "adm0_code": 40765,
                "adm0_name": "Egypt",
                "coordinates": { "lat": 26.8206, "lng": 30.8025, "zoom": 5 }
            },
            {
                "adm0_code": 76,
                "adm0_name": "Equatorial Guinea",
                "coordinates": { "lat": 1.6508, "lng": 10.2679, "zoom": 6 }
            },
            {
                "adm0_code": 77,
                "adm0_name": "Eritrea",
                "coordinates": { "lat": 15.1794, "lng": 39.7823, "zoom": 7 }
            },
            {
                "adm0_code": 79,
                "adm0_name": "Ethiopia",
                "coordinates": { "lat": 9.145, "lng": 40.4897, "zoom": 5 }
            },
            {
                "adm0_code": 89,
                "adm0_name": "Gabon",
                "coordinates": { "lat": -0.8037, "lng": 11.6094, "zoom": 7 }
            },
            {
                "adm0_code": 90,
                "adm0_name": "Gambia",
                "coordinates": { "lat": 13.4432, "lng": -15.3101, "zoom": 7 }
            },
            {
                "adm0_code": 94,
                "adm0_name": "Ghana",
                "coordinates": { "lat": 7.9465, "lng": -1.0232, "zoom": 6 }
            },
            {
                "adm0_code": 96,
                "adm0_name": "Glorioso Island",
                "coordinates": { "lat": -11.8, "lng": 47.3, "zoom": 8 }
            },
            {
                "adm0_code": 105,
                "adm0_name": "Guinea-Bissau",
                "coordinates": { "lat": 11.8037, "lng": -15.1804, "zoom": 7 }
            },
            {
                "adm0_code": 106,
                "adm0_name": "Guinea",
                "coordinates": { "lat": 9.9456, "lng": -9.6966, "zoom": 6 }
            },
            {
                "adm0_code": 40760,
                "adm0_name": "Hala'ib triangle",
                "coordinates": { "lat": 22.0, "lng": 35.0, "zoom": 7 }
            },
            {
                "adm0_code": 61013,
                "adm0_name": "Ilemi triangle",
                "coordinates": { "lat": 4.0, "lng": 35.0, "zoom": 7 }
            },
            {
                "adm0_code": 131,
                "adm0_name": "Juan de Nova Island",
                "coordinates": { "lat": -17.0333, "lng": 42.8333, "zoom": 8 }
            },
            {
                "adm0_code": 133,
                "adm0_name": "Kenya",
                "coordinates": { "lat": -1.2921, "lng": 36.8219, "zoom": 6 }
            },
            {
                "adm0_code": 142,
                "adm0_name": "Lesotho",
                "coordinates": { "lat": -29.6091, "lng": 28.2336, "zoom": 7 }
            },
            {
                "adm0_code": 144,
                "adm0_name": "Liberia",
                "coordinates": { "lat": 6.4281, "lng": -9.4295, "zoom": 6 }
            },
            {
                "adm0_code": 145,
                "adm0_name": "Libya",
                "coordinates": { "lat": 26.3351, "lng": 17.2283, "zoom": 5 }
            },
            {
                "adm0_code": 40762,
                "adm0_name": "Ma'tan al-Sarra",
                "coordinates": { "lat": 23.0, "lng": 26.0, "zoom": 7 }
            },
            {
                "adm0_code": 150,
                "adm0_name": "Madagascar",
                "coordinates": { "lat": -18.7669, "lng": 46.8691, "zoom": 6 }
            },
            {
                "adm0_code": 151,
                "adm0_name": "Madeira Islands",
                "coordinates": { "lat": 32.7607, "lng": -16.9595, "zoom": 8 }
            },
            {
                "adm0_code": 152,
                "adm0_name": "Malawi",
                "coordinates": { "lat": -13.2543, "lng": 34.3015, "zoom": 6 }
            },
            {
                "adm0_code": 155,
                "adm0_name": "Mali",
                "coordinates": { "lat": 17.5707, "lng": -3.9962, "zoom": 6 }
            },
            {
                "adm0_code": 159,
                "adm0_name": "Mauritania",
                "coordinates": { "lat": 21.0079, "lng": -10.9402, "zoom": 6 }
            },
            {
                "adm0_code": 160,
                "adm0_name": "Mauritius",
                "coordinates": { "lat": -20.348404, "lng": 57.552152, "zoom": 8 }
            },
            {
                "adm0_code": 161,
                "adm0_name": "Mayotte",
                "coordinates": { "lat": -12.8275, "lng": 45.1662, "zoom": 8 }
            },
            {
                "adm0_code": 169,
                "adm0_name": "Morocco",
                "coordinates": { "lat": 31.7917, "lng": -7.0926, "zoom": 5 }
            },
            {
                "adm0_code": 170,
                "adm0_name": "Mozambique",
                "coordinates": { "lat": -18.6657, "lng": 35.5296, "zoom": 6 }
            },
            {
                "adm0_code": 172,
                "adm0_name": "Namibia",
                "coordinates": { "lat": -22.3285, "lng": 17.2232, "zoom": 6 }
            },
            {
                "adm0_code": 181,
                "adm0_name": "Niger",
                "coordinates": { "lat": 17.6078, "lng": 8.0817, "zoom": 6 }
            },
            {
                "adm0_code": 182,
                "adm0_name": "Nigeria",
                "coordinates": { "lat": 9.082, "lng": 8.6753, "zoom": 5 }
            },
            {
                "adm0_code": 205,
                "adm0_name": "Rwanda",
                "coordinates": { "lat": -1.9403, "lng": 29.8739, "zoom": 7 }
            },
            {
                "adm0_code": 206,
                "adm0_name": "Réunion",
                "coordinates": { "lat": -21.1151, "lng": 55.5364, "zoom": 8 }
            },
            {
                "adm0_code": 207,
                "adm0_name": "Saint Helena",
                "coordinates": { "lat": -15.931, "lng": -5.0709, "zoom": 8 }
            },
            {
                "adm0_code": 214,
                "adm0_name": "Sao Tome and Principe",
                "coordinates": { "lat": 0.1864, "lng": 6.6131, "zoom": 8 }
            },
            {
                "adm0_code": 217,
                "adm0_name": "Senegal",
                "coordinates": { "lat": 14.4974, "lng": -14.4524, "zoom": 6 }
            },
            {
                "adm0_code": 220,
                "adm0_name": "Seychelles",
                "coordinates": { "lat": -4.6796, "lng": 55.492, "zoom": 8 }
            },
            {
                "adm0_code": 221,
                "adm0_name": "Sierra Leone",
                "coordinates": { "lat": 8.4606, "lng": -11.7799, "zoom": 6 }
            },
            {
                "adm0_code": 226,
                "adm0_name": "Somalia",
                "coordinates": { "lat": 5.1521, "lng": 46.1996, "zoom": 6 }
            },
            {
                "adm0_code": 227,
                "adm0_name": "South Africa",
                "coordinates": { "lat": -30.5595, "lng": 22.9375, "zoom": 5 }
            },
            {
                "adm0_code": 74,
                "adm0_name": "South Sudan",
                "coordinates": { "lat": 6.877, "lng": 31.307, "zoom": 6 }
            },
            {
                "adm0_code": 229,
                "adm0_name": "Spain",
                "coordinates": { "lat": 40.4637, "lng": -3.7492, "zoom": 4 }
            },
            {
                "adm0_code": 6,
                "adm0_name": "Sudan",
                "coordinates": { "lat": 15.5007, "lng": 32.5599, "zoom": 6 }
            },
            {
                "adm0_code": 235,
                "adm0_name": "Swaziland",
                "coordinates": { "lat": -26.5225, "lng": 31.4659, "zoom": 7 }
            },
            {
                "adm0_code": 243,
                "adm0_name": "Togo",
                "coordinates": { "lat": 7.4465, "lng": 1.5021, "zoom": 7 }
            },
            {
                "adm0_code": 247,
                "adm0_name": "Tromelin Island",
                "coordinates": { "lat": -15.875, "lng": 54.423, "zoom": 8 }
            },
            {
                "adm0_code": 248,
                "adm0_name": "Tunisia",
                "coordinates": { "lat": 33.8869, "lng": 9.5375, "zoom": 6 }
            },
            {
                "adm0_code": 253,
                "adm0_name": "Uganda",
                "coordinates": { "lat": 1.3733, "lng": 32.2903, "zoom": 6 }
            },
            {
                "adm0_code": 258,
                "adm0_name": "Zambia",
                "coordinates": { "lat": -13.1339, "lng": 27.8493, "zoom": 6 }
            },
            {
                "adm0_code": 263,
                "adm0_name": "Zimbabwe",
                "coordinates": { "lat": -19.0154, "lng": 29.1549, "zoom": 6 }
            }
        ]

        let country = countries.filter(country => country.adm0_code == country_id);
        return country[0].coordinates || { coordinates: [0.0, 20.0], zoom: 4 };
    }

    const handleApply = (passedHazard = null) => {
        let chartData = totalHazardData;

        if (Array.isArray(selectedCountries) && selectedCountries.length > 0) {
            chartData = chartData.filter(item => selectedCountries.includes(item.adm0_code));
        }

        let text = "province"; // Default value

        if (Array.isArray(selectedCountries) && selectedCountries.length > 1) {
            text = "country";
        }

        if (Array.isArray(selectedProvinces) && selectedProvinces.length > 0) {
            text = "district";
            chartData = chartData.filter(item => selectedProvinces.includes(item.adm1_code));
        }

        setHeadingText(text);
        getHazardsCount(chartData);

        let selectedHazard = (passedHazard && typeof passedHazard === "object" && "hazard_id" in passedHazard)
            ? passedHazard
            : hazards.find(item => item.hazard_id === selectedHazards?.hazard_id);

        setSelectedHazards(selectedHazard);
        setDisplayHazard(selectedHazard);

        getTop10Data(chartData, selectedHazard?.symbol, text);

        let deathData = totaldeathData;
        if (Array.isArray(selectedCountries) && selectedCountries.length > 0) {
            deathData = deathData.filter(item => selectedCountries.includes(item.adm0_code));
        }
        if (Array.isArray(selectedProvinces) && selectedProvinces.length > 0) {
            deathData = deathData.filter(item => selectedProvinces.includes(item.adm1_code));
        }

        let economicData = totaleconomicData;
        if (Array.isArray(selectedCountries) && selectedCountries.length > 0) {
            economicData = economicData.filter(item => selectedCountries.includes(item.adm0_code));
        }
        if (Array.isArray(selectedProvinces) && selectedProvinces.length > 0) {
            economicData = economicData.filter(item => selectedProvinces.includes(item.adm1_code));
        }

        if (selectedHazard?.symbol !== "F") {
            setDeathLossData(null);
            setEconomicLossData(null);
        } else {
            getLossesData(deathData, text, "death");
            getLossesData(economicData, text, "economic");
        }

        getTableData(chartData, deathData, economicData);
        if (geoJsonData) {
            generateMapDataFromGeoJSON(geoJsonData, chartData)
        }

        if (selectedCountries && selectedCountries.length == 1) {
            const coordinates = getCountryCoordinates(selectedCountries[0]);
            setGetZoom({
                coordinates: [coordinates.lat, coordinates.lng],
                zoom: coordinates.zoom
            });
        } else {
            setGetZoom({ coordinates: [0.0, 20.0], zoom: 4 })
        }

        if (activeTab === 'map') {
            scrollBottom()
        }
    };

    useEffect(() => {
        if (selectedHazards) {
            handleApply(selectedHazards);
            getHeadingName();
        }
    }, [selectedHazards, selectedCountries, selectedProvinces])

    const handleCountryChange = (event) => {
        const countryId = event.target.value;
        if (countryId == '') {
            setSelectedCountries(null);
            setFilteredProvinces([])
        } else {
            setSelectedCountries([+countryId]);
            const filtered = provinces.filter(item => item.adm0_code == countryId)
            setFilteredProvinces(filtered)
        }
    };

    const handleProvinceChange = (event) => {
        const provinceId = event.target.value;
        if (provinceId == '') {
            setSelectedProvinces(null);
        } else {
            setSelectedProvinces([+provinceId]);
        }
    };

    const handleHazardChange = (event) => {
        const selectedHazardId = event.target.value;
        const selectedHazard = hazards.find((hazard) => hazard.hazard_id === parseInt(selectedHazardId, 10));
        setSelectedHazards(selectedHazard);
    };

    const hazardDataFilter = (hazard) => {
        handleApply(hazard);
    };

    const scrollBottom = () => {
        // Scroll to the bottom of the page
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth',  // Smooth scroll effect
        });
    }

    const LookUpLoader = () => (
        <div className="loader-container" style={{ position: 'fixed', marginTop: '-36px', height: '100vh' }}>
            <div className="spinner-border text-primary" role="status" style={{ width: '1rem', height: '1rem' }}>
                <span className="sr-only"></span>
            </div>
        </div>
    );

    const getHeadingName = () => {
        let text = "Africa"; // Default value

        if (selectedCountries?.length === 1) {
            const country = countries.find(item => item.adm0_code === selectedCountries[0]);
            if (country) text = country.adm0_name;
        }
        if (selectedProvinces?.length === 1) {
            const province = provinces.find(item => item.adm1_code === selectedProvinces[0]);
            if (province) text = province.adm1_name;
        }
        setHeadingName(text)
    };

    const downloadTable1 = () => {
        if (!window.XLSX) {
            console.error("XLSX library is not loaded.");
            return;
        }

        let workbook = window.XLSX.utils.book_new();
        let sheetData = [];

        document.querySelectorAll("table").forEach((table, index) => {
            let rows = table.querySelectorAll("tr");
            let tableData = [];

            rows.forEach((row, rowIndex) => {
                let rowData = [];
                row.querySelectorAll("th, td").forEach((cell) => {
                    rowData.push(cell.innerText);
                });
                tableData.push(rowData);
            });

            // Append table data to the sheetData array
            sheetData = [...sheetData, ...tableData];

            // Add a blank row after each table (except the last one)
            if (index !== document.querySelectorAll("table").length - 1) {
                sheetData.push([]);
            }
        });

        let worksheet = window.XLSX.utils.aoa_to_sheet(sheetData);

        // Apply bold formatting to the first row of each table
        let range = window.XLSX.utils.decode_range(worksheet["!ref"]);
        let currentRow = 0;

        document.querySelectorAll("table").forEach((table, index) => {
            let headerRowLength = table.querySelectorAll("tr")[0].querySelectorAll("th, td").length;
            for (let c = 0; c < headerRowLength; c++) {
                let cellAddress = window.XLSX.utils.encode_cell({ r: currentRow, c });
                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = { font: { bold: true } };
                }
            }
            // Move to the next table's header row (skip one row for spacing)
            currentRow += table.querySelectorAll("tr").length + 1;
        });

        window.XLSX.utils.book_append_sheet(workbook, worksheet, "Tables");
        window.XLSX.writeFile(workbook, "table_data.xlsx");
    };

    return (
        <>
            {loading ? (
                <div style={{ margin: "100px 0 0 0" }}>
                    <LookUpLoader />
                </div>
            ) : ('')}
            <section className="bg-light mt-59px" style={{ background: '#fafafa' }}>
                <div className="container-fluid">

                    <div className="row py-3">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                    <h3 className="analytic-text mb-0">Hazard occurrences in {headingName}</h3>
                                </div>

                                <div className="d-flex flex-wrap">
                                    <div className="mx-2 w-200px">
                                        <label className="textLabel">country</label>
                                        <select className="form-select formText" defaultValue="" onChange={handleCountryChange}>
                                            <option value="">All Selected</option>
                                            {countries.map((country) => (
                                                <option key={country.adm0_code} value={country.adm0_code}>
                                                    {country.adm0_name}
                                                </option>
                                            ))}
                                        </select>
                                        {/* <MultiSelect value={selectedCountries} onChange={(e) => setSelectedCountries(e.value)} options={countries} optionLabel="adm0_name"
                                            filter placeholder="All Countries" maxSelectedLabels={3} className="" /> */}
                                    </div>
                                    <div className="mx-2 w-200px">
                                        <label className="textLabel">Provinces</label>
                                        <select
                                            key={filteredProvinces.length} // Changing key forces a full re-render
                                            className="form-select formText"
                                            defaultValue=""
                                            onChange={handleProvinceChange}
                                        >
                                            <option value="">All Selected</option>
                                            {filteredProvinces.map((province) => (
                                                <option key={province.adm1_code} value={province.adm1_code}>
                                                    {province.adm1_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mx-2 w-200px">
                                        <label className="textLabel">Hazards</label>
                                        <select className="form-select formText" value={selectedHazards?.hazard_id} onChange={handleHazardChange}>
                                            {hazards.map((hazard) => (
                                                <option key={hazard.hazard_id} value={hazard.hazard_id}>
                                                    {hazard.hazard}
                                                </option>
                                            ))}
                                        </select>
                                        {/* <MultiSelect value={selectedHazards} onChange={(e) => setSelectedHazards(e.value)} options={hazards} optionLabel="hazard"
                                            filter placeholder="All Hazards" maxSelectedLabels={3} className="" /> */}
                                    </div>
                                    {/* {!loading && <div><button className="btn btn-applys mt-25px" onClick={handleApply}>Apply</button></div>} */}
                                    {/* <div className="mx-2"><button className="btn btn-export1 border mt-25px"><span><img src="/assets/images/export-chart.svg" alt="" className="me-1" /></span> Export</button></div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="d-flex justify-content-start align-items-center flex-wrap">
                                {hazards
                                    ?.slice()
                                    .sort((a, b) => (hazardsCount?.[b.symbol] ?? 0) - (hazardsCount?.[a.symbol] ?? 0))
                                    .map(item => (
                                        <div
                                            className="boxCardAll"
                                            style={{ backgroundColor: item.hazard_id === selectedHazards.hazard_id ? 'lightblue' : '' }}
                                            key={item.symbol}
                                            onClick={() => hazardDataFilter(item)}
                                        >
                                            <div className="">
                                                <div><p className="mb-0">{item.hazard}</p></div>
                                                <div className="d-flex justify-content-between">
                                                    <h4 className="mt-2">{(hazardsCount && hazardsCount[item.symbol]) ?? 0}</h4>
                                                    <span className="mb-0 text-right">
                                                        <img className="" src={`/assets/images/hazard-${item.hazard_id}-a4.svg`} alt={item.hazard} />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between">
                                        <div><h3 className="analytic-text mb-0">{displayHazard?.hazard ?? ''} Details</h3></div>
                                        <div>
                                            <button
                                                className={`btn btn-chart me-2 ${activeTab === 'chart' ? 'active' : ''}`}
                                                onClick={handleChartClick}
                                            >
                                                <span><img src="/assets/images/pie-chart.svg" alt="Chart" /></span> Charts
                                            </button>
                                            <button
                                                className={`btn btn-table me-2 ${activeTab === 'table' ? 'active' : ''}`}
                                                onClick={handleTableClick}
                                            >
                                                <span><img src="/assets/images/table.svg" alt="Table" /></span> Table
                                            </button>
                                            <button
                                                className={`btn btn-table me-2 ${activeTab === 'map' ? 'active' : ''}`}
                                                onClick={handleMapClick}
                                            >
                                                <span><img src="/assets/images/Map.svg" alt="map" /></span> Map
                                            </button>

                                            {/* <button
                                                className={`btn btn-table ${activeTab === 'sample' ? 'active' : ''}`}
                                                onClick={handleSampleClick}
                                            >
                                                <span><img src="/assets/images/table.svg" alt="sample" /></span> Sample Table
                                            </button> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div>
                                        <div className="tab-content">
                                            {activeTab === 'chart' && (
                                                <div className="chart-data">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                                            <div className="card analysisCard">
                                                                <div className="card-body">
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div><h6>Top 10 {headingText == "country" ? "countries" : headingText == "district" ? "districts" : "provinces"} by {displayHazard?.hazard ?? ''} occurrences <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                                                        <div>
                                                                            <button className="btn btn-export2 me-2" onClick={handleShow}><span><img src="/assets/images/expand.svg" alt="" className="" /></span> </button>
                                                                            <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" onClick={() => handleDownload(chartRef)} /></span> </button>
                                                                        </div>
                                                                    </div>
                                                                    <p>The tool tracks natural disasters, identifying the top 10 most flood-affected countries since 1990. Typically, these include Kenya, Malawi, Mozambique, Algeria, Angola, Nigeria, Mali, and Sudan. However, rankings may vary by year, and the database will be periodically updated to reflect the latest data.</p>
                                                                    {hazardChartData ? <HazardOccurencesChart ref={chartRef} chartData={hazardChartData} headingText={headingText} /> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {deathLossData ?
                                                            <div className="col-sm-12 col-md-6 col-lg-6">
                                                                <div className="card analysisCard">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div><h6>No.of deaths by {headingText} by {displayHazard?.hazard ?? ''}  <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                                                            <div>
                                                                                <button className="btn btn-export2 me-2" onClick={handleShow1}><span><img src="/assets/images/expand.svg" alt="" className="" /></span> </button>
                                                                                <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" onClick={() => handleDownload(chartRef1)} /></span> </button>
                                                                            </div>
                                                                        </div>

                                                                        <p>This tool tracks reported flood-related deaths since 1990, providing country-level and year-wise details up to 2020. The visualizer offers valuable insights for disaster risk management and adaptation investments. Rankings may vary annually, and the database is regularly updated to reflect the latest data.                                                                        </p>
                                                                        <HazardLossChart ref={chartRef1} lossData={deathLossData} type={'death'} />
                                                                    </div>
                                                                </div>
                                                            </div> : null}

                                                        {economicLossData ? <div className="col-sm-12 col-md-6 col-lg-6">
                                                            <div className="card analysisCard">
                                                                <div className="card-body">
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div><h6>Economic Loss by {headingText} by {displayHazard?.hazard ?? ''}  <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                                                        <div>
                                                                            <button className="btn btn-export2 me-2" onClick={handleShow2}><span><img src="/assets/images/expand.svg" alt="" className="" /></span> </button>
                                                                            <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" onClick={() => handleDownload(chartRef2)} /></span> </button>
                                                                        </div>
                                                                    </div>

                                                                    <p>This tool provides year-wise economic loss data from floods, as reported by relevant authorities at the country level since 1990. This information is crucial for climate finance, supporting targeted climate preparedness to reduce exposure among vulnerable populations and mitigate infrastructure losses. The database is regularly updated to reflect the latest data.</p>
                                                                    <HazardLossChart ref={chartRef2} lossData={economicLossData} type={'economic'} />
                                                                </div>
                                                            </div>
                                                        </div> : null}


                                                    </div>
                                                </div>
                                            )}
                                            {activeTab === 'table' && (
                                                <>
                                                    {/* <button className="btn btn-export2" style={{ float: "right" }} onClick={downloadTable1}>
                                                        <span>
                                                            <img src="/assets/images/export-chart.svg" alt="Download" className="" />
                                                        </span>
                                                    </button> */}

                                                    <div className="table-data">

                                                        {Array.isArray(tableHazardData) && tableHazardData.length > 0 ? (
                                                            tableHazardData.map((country, countryIndex) => (
                                                                <React.Fragment key={`country-${country.country_code}-${countryIndex}`}>
                                                                    <div className="d-flex justify-content-between w-100 align-items-center mb-3 mt-2">
                                                                        <div><h3 className="mb-0 country-title">{country.country}</h3></div>
                                                                    </div>
                                                                    <h3 className="chart-title">Total Hazard Occurrences by {headingText == "country" ? "Country" : "Province"}</h3>
                                                                    <div key={`table-${country.country_code}`} className="table-responsive">
                                                                        <table className="table table-bordered tbl_new table-hover">
                                                                            <thead>
                                                                                <tr className="table100-head">
                                                                                    <th rowSpan="1"></th>
                                                                                    {hazards
                                                                                        .slice()
                                                                                        .sort((a, b) => a.symbol.localeCompare(b.symbol))
                                                                                        .map((item, hazardIndex) => (
                                                                                            <th colSpan="1" key={`hazard-${item.hazard_id}-${hazardIndex}`}>{item.hazard}</th>
                                                                                        ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        <span
                                                                                            className="expand-icon"
                                                                                            onClick={() => toggleCountry1(country.country_code)}
                                                                                        >
                                                                                            {expandedCountries1[country.country_code] ? '▼' : '▶'}
                                                                                        </span>
                                                                                        {country.country}
                                                                                    </td>
                                                                                    {Object.values(country.values).map((item, valueIndex) => (
                                                                                        <td colSpan="1" key={`country-value-${country.country_code}-${valueIndex}`}>{item}</td>
                                                                                    ))}
                                                                                </tr>
                                                                                {expandedCountries1[country.country_code] && (
                                                                                    country.provinces.map((province, provinceIndex) => (
                                                                                        <React.Fragment key={`province-${province.province_code}-${provinceIndex}`}>
                                                                                            <tr>
                                                                                                <td>
                                                                                                    &emsp;
                                                                                                    <span
                                                                                                        className="expand-icon"
                                                                                                        onClick={() => toggleProvince1(province.province_code)}
                                                                                                    >
                                                                                                        {expandedProvinces1[province.province_code] ? '▼' : '▶'}
                                                                                                    </span>
                                                                                                    {province.province}
                                                                                                </td>
                                                                                                {Object.values(province.values).map((provinceValue, index) => (
                                                                                                    <td key={`province-${province.province_code}-value-${index}`}>{provinceValue}</td>
                                                                                                ))}
                                                                                            </tr>

                                                                                            {expandedProvinces1[province.province_code] && (
                                                                                                province.districts.map((district, districtIndex) => (
                                                                                                    <tr key={`district-${district.district_code}-${districtIndex}`}>
                                                                                                        <td>&emsp;&emsp;&emsp;&emsp;{district.district}</td>
                                                                                                        {Object.values(district.values).map((districtValue, index) => (
                                                                                                            <td key={`district-${district.district_code}-value-${index}`}>{districtValue}</td>
                                                                                                        ))}
                                                                                                    </tr>
                                                                                                ))
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    ))
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {selectedHazards?.symbol == "F" && (
                                                                        <>
                                                                            {/* Death Data Table */}
                                                                            <h3 className="chart-title mt-4">Number of Death by {displayHazard?.hazard ?? ''}</h3>
                                                                            <div className="table-responsive">
                                                                                <table className="table table-bordered tbl_new table-hover">
                                                                                    <thead>
                                                                                        <tr className="table100-head">
                                                                                            <th rowSpan="2"></th>
                                                                                            <th className="text-center" colSpan={years.length}> Number of Deaths by {displayHazard?.hazard ?? ''}</th>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {years.map((item, yearIndex) => (
                                                                                                <th colSpan="1" key={`year-${yearIndex}`}>{item}</th>
                                                                                            ))}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <span
                                                                                                    className="expand-icon"
                                                                                                    onClick={() => toggleCountry2(country.country_code)}
                                                                                                >
                                                                                                    {expandedCountries2[country.country_code] ? '▼' : '▶'}
                                                                                                </span>
                                                                                                {country.country}
                                                                                            </td>
                                                                                            {Object.values(country.temporalDeath).map((item, index) => (
                                                                                                <td key={`death-${country.country_code}-value-${index}`}>{item}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                        {expandedCountries2[country.country_code] && (
                                                                                            country.provinces.map((province, provinceIndex) => (
                                                                                                <React.Fragment key={`death-province-${province.province_code}-${provinceIndex}`}>
                                                                                                    <tr>
                                                                                                        <td>
                                                                                                            &emsp;
                                                                                                            <span
                                                                                                                className="expand-icon"
                                                                                                                onClick={() => toggleProvince2(province.province_code)}
                                                                                                            >
                                                                                                                {expandedProvinces2[province.province_code] ? '▼' : '▶'}
                                                                                                            </span>
                                                                                                            {province.province}
                                                                                                        </td>
                                                                                                        {Object.values(province.temporalDeath).map((provinceValue, index) => (
                                                                                                            <td key={`death-province-${province.province_code}-value-${index}`}>{provinceValue}</td>
                                                                                                        ))}
                                                                                                    </tr>
                                                                                                    {expandedProvinces2[province.province_code] && (
                                                                                                        province.districts.map((district, districtIndex) => (
                                                                                                            <tr key={`death-district-${district.district_code}-${districtIndex}`}>
                                                                                                                <td>&emsp;&emsp;&emsp;&emsp;{district.district}</td>
                                                                                                                {Object.values(district.temporalDeath).map((districtValue, index) => (
                                                                                                                    <td key={`death-district-${district.district_code}-value-${index}`}>{districtValue}</td>
                                                                                                                ))}
                                                                                                            </tr>
                                                                                                        ))
                                                                                                    )}
                                                                                                </React.Fragment>
                                                                                            ))
                                                                                        )}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>

                                                                            {/* Economic Damage Table */}
                                                                            <h3 className="chart-title mt-4">Economic damage by  {displayHazard?.hazard ?? ''}</h3>
                                                                            <div className="table-responsive">
                                                                                <table className="table table-bordered tbl_new table-hover">
                                                                                    <thead>
                                                                                        <tr className="table100-head">
                                                                                            <th rowSpan="2"></th>
                                                                                            <th className="text-center" colSpan={years.length}>Economic Damage by {displayHazard?.hazard ?? ''}</th>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {years.map((item, yearIndex) => (
                                                                                                <th colSpan="1" key={`economic-year-${yearIndex}`}>{item}</th>
                                                                                            ))}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <span
                                                                                                    className="expand-icon"
                                                                                                    onClick={() => toggleCountry3(country.country_code)}
                                                                                                >
                                                                                                    {expandedCountries3[country.country_code] ? '▼' : '▶'}
                                                                                                </span>
                                                                                                {country.country}
                                                                                            </td>
                                                                                            {Object.values(country.temporalEconomic).map((item, index) => (
                                                                                                <td key={`economic-${country.country_code}-value-${index}`}>{item}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                        {expandedCountries3[country.country_code] && (
                                                                                            country.provinces.map((province, provinceIndex) => (
                                                                                                <React.Fragment key={`economic-province-${province.province_code}-${provinceIndex}`}>
                                                                                                    <tr>
                                                                                                        <td>
                                                                                                            &emsp;
                                                                                                            <span
                                                                                                                className="expand-icon"
                                                                                                                onClick={() => toggleProvince3(province.province_code)}
                                                                                                            >
                                                                                                                {expandedProvinces3[province.province_code] ? '▼' : '▶'}
                                                                                                            </span>
                                                                                                            {province.province}
                                                                                                        </td>
                                                                                                        {Object.values(province.temporalEconomic).map((provinceValue, index) => (
                                                                                                            <td key={`economic-province-${province.province_code}-value-${index}`}>{provinceValue}</td>
                                                                                                        ))}
                                                                                                    </tr>
                                                                                                    {expandedProvinces3[province.province_code] && (
                                                                                                        province.districts.map((district, districtIndex) => (
                                                                                                            <tr key={`economic-district-${district.district_code}-${districtIndex}`}>
                                                                                                                <td>&emsp;&emsp;&emsp;&emsp;{district.district}</td>
                                                                                                                {Object.values(district.temporalEconomic).map((districtValue, index) => (
                                                                                                                    <td key={`economic-district-${district.district_code}-value-${index}`}>{districtValue}</td>
                                                                                                                ))}
                                                                                                            </tr>
                                                                                                        ))
                                                                                                    )}
                                                                                                </React.Fragment>
                                                                                            ))
                                                                                        )}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            <p>No data available</p>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            {activeTab === 'map' && (
                                                <AnalysisMap selectedDataMap={selectedDataMap} getZoom={getZoom} />
                                            )}
                                            {activeTab === 'sample' && (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div><h3 className="mb-0 country-title mb-3">Burundi</h3>
                                                            <h3 className="chart-title">Occurrences by Province</h3></div>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table tbl_new text-center">
                                                            <thead className="bg-light">

                                                                <tr>
                                                                    <th>Gitega</th>
                                                                    <th>Mwaro</th>
                                                                    <th>Bururi</th>
                                                                    <th>Bujumbura Rural</th>
                                                                    <th>Makamba</th>
                                                                    <th>Bubanza</th>
                                                                    <th>Cibitoke</th>
                                                                    <th>Kayanza</th>
                                                                    <th>Muramvya</th>
                                                                    <th>Rutana</th>
                                                                    <th>Ruyigi</th>
                                                                    <th>Karuzi</th>
                                                                    <th>Ngozi</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>3</td>
                                                                    <td>0</td>
                                                                    <td>6</td>
                                                                    <td>11</td>
                                                                    <td>6</td>
                                                                    <td>14</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <h3 className="chart-title">Occurrences by Distrcit</h3>
                                                    <div className="table-responsive">
                                                        <table className="table tbl_new text-center">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>Ryansoro</th>
                                                                    <th>Bugendana</th>
                                                                    <th>Buraza</th>
                                                                    <th>Nyanrusange</th>
                                                                    <th>Gishubi</th>
                                                                    <th>Giheta</th>
                                                                    <th>Itaba</th>
                                                                    <th>Bukirasazi</th>
                                                                    <th>Gitega</th>
                                                                    <th>Makebuko</th>
                                                                    <th>Mutaho</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                    <td>2</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="modal-90w">
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 analysisCard1">
                            <div className="d-flex justify-content-between align-items-center ">
                                <div><h6>Top 10 {headingText == "country" ? "countries" : headingText == "district" ? "districts" : "provinces"} by {displayHazard?.hazard ?? ''} occurrences  <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                <div>
                                    <button className="btn btn-export2 me-2" onClick={handleClose}><span><img src="/assets/images/close.svg" alt="" className="" /></span> </button>
                                    {/* <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" /></span> </button> */}
                                </div>
                            </div>
                            <p>The tool tracks natural disasters, identifying the top 10 most flood-affected countries since 1990. Typically, these include Kenya, Malawi, Mozambique, Algeria, Angola, Nigeria, Mali, and Sudan. However, rankings may vary by year, and the database will be periodically updated to reflect the latest data.</p>
                            {hazardChartData ? <HazardOccurencesChart chartData={hazardChartData} headingText={headingText} /> : null}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show1} onHide={handleClose1} size="lg" centered dialogClassName="modal-90w">
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 analysisCard1">
                            <div className="d-flex justify-content-between align-items-center ">
                                <div><h6>No.of deaths by {headingText} by {displayHazard?.hazard ?? ''}  <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                <div>
                                    <button className="btn btn-export2 me-2" onClick={handleClose1}><span><img src="/assets/images/close.svg" alt="" className="" /></span> </button>
                                    {/* <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" /></span> </button> */}
                                </div>
                            </div>
                            <p>This tool tracks reported flood-related deaths since 1990, providing country-level and year-wise details up to 2020. The visualizer offers valuable insights for disaster risk management and adaptation investments. Rankings may vary annually, and the database is regularly updated to reflect the latest data.</p>
                            {deathLossData ? <HazardLossChart lossData={deathLossData} type={'death'} /> : null}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show2} onHide={handleClose2} size="lg" centered dialogClassName="modal-90w">
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 analysisCard1">
                            <div className="d-flex justify-content-between align-items-center ">
                                <div><h6>Economic Loss by {headingText} by {displayHazard?.hazard ?? ''}  <span><img src="/assets/images/info.svg" alt="" className="me-1" /></span></h6></div>
                                <div>
                                    <button className="btn btn-export2 me-2" onClick={handleClose2}><span><img src="/assets/images/close.svg" alt="" className="" /></span> </button>
                                    {/* <button className="btn btn-export2"><span><img src="/assets/images/export-chart.svg" alt="" className="" /></span> </button> */}
                                </div>
                            </div>
                            <p>This tool provides year-wise economic loss data from floods, as reported by relevant authorities at the country level since 1990. This information is crucial for climate finance, supporting targeted climate preparedness to reduce exposure among vulnerable populations and mitigate infrastructure losses. The database is regularly updated to reflect the latest data.</p>
                            {economicLossData ? <HazardLossChart lossData={economicLossData} type={'economic'} /> : null}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
}

export default DashboardAnalysisTabLatest;
